import actions from "@/store/actions/cameraAction"; // import getters from "@/store/getters/maskGetter";

/**
 *  mask
 */

export default {
  state: {},
  actions: actions
};